// extracted by mini-css-extract-plugin
export default {"host":"ContextMenuItem_host__SYy07","inner":"ContextMenuItem_inner__r95F4"};